'use client';

import { useAffiliateLink } from '@hooks/use-affiliate-link';
import { Share02 } from '@v2/ui/Icon/Share02/Share02';
import { cn } from '@v2/utils/cn';

type Props = {
  variant?: 'primary' | 'secondary';
};

export function AffiliateLinkCopyButton({ variant = 'primary' }: Props) {
  const { isLoading, link, onCopyButtonClick } = useAffiliateLink();

  if (isLoading || !link) {
    return null;
  }

  const styleVariants = {
    primary: 'text-white',
    secondary: ' text-gray-800',
  };

  return (
    <button
      className={cn(
        `cursor-pointer rounded-full border border-gray-300 p-2.5 ${styleVariants[variant]}`
      )}
      onClick={() => onCopyButtonClick()}
    >
      <Share02 size="20" pathProps={{ stroke: 'currentColor' }} />
    </button>
  );
}
